import { type ComponentType, lazy } from 'react';

/**
 * ページコンポーネントを初回表示時に読み込む React.lazy の薄いラッパー。
 *
 * ページは名前付き export なので、default export を要求する React.lazy に合わせて詰め替える。
 * 同じモジュールの複数ページを別々に lazyPage しても、import() はモジュール単位でキャッシュされ
 * チャンクも1つにまとまるため、取得は1回で済む。
 */
export const lazyPage = <M extends Record<K, ComponentType<object>>, K extends keyof M & string>(
  load: () => Promise<M>,
  name: K,
) => lazy(() => load().then((module) => ({ default: module[name] })));
